import NoImg from "global/images/avatar.jpg";

export const getImageSrc = (img: string | File | null): string => {
  if (!img) return NoImg;

  if (typeof img === "string") {
    if (img.startsWith("data:image")) {
      return img;
    }

    if (img.startsWith("http") || img.startsWith("/")) {
      return img;
    }

    return `data:image/png;base64,${img}`;
  }

  if (img instanceof File) {
    return URL.createObjectURL(img);
  }

  return NoImg;
};
